import getAxiosClient from "@cv/utils/getAxiosClient";

const sendCV = (action, data) => {
    return getAxiosClient().post(action, data);
};

export default sendCV;